import React from "react";
import DveleMap from "./map";
import LocationModal from "./location_modal";
import { useJsApiLoader } from "@react-google-maps/api";
import { useStore } from "./state";
import shallow from "zustand/shallow";
import StaticMap from "./static_map2";
import Papa from "papaparse";
import { minBy, maxBy } from "lodash";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { loadLocations } from "./data";

const locations = loadLocations();

function App() {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyARCB6-a8dyszVFKZX_L94S5veDRm6o0Fs",
  });
  const [modalShow, setModalShow, location, setLocation] =
    React.useState(false);
  const { active_location, chart_range, setChartRange } = useStore(
    (state) => ({
      active_location: state.active_location,
      location_data: state.location_data,
      chart_range: state.chart_range,
      setChartRange: state.setChartRange,
    }),
    shallow
  );

  const renderMap = () => {
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "row",
        }}
      >
        {/*<a
          href="https://www.dvele.com"
          style={{
            display: "block",
            position: "absolute",
            zIndex: 100,
            top: 10,
            left: 10,
          }}
        >
          <img
            src="logo_black.png"
            alt="Dvele"
            style={{
              height: "auto",
              width: 200,
            }}
          />
        </a>*/}
        <div style={{ flex: 1, height: "100%", backgroundColor: "#fff" }}>
          {!!active_location && !!active_location.name && (
            <LocationModal modalShow={modalShow} setModalShow={setModalShow} />
          )}
          {
            <StaticMap
              modalShow={() => setModalShow(true)}
              locations={locations}
            />
          }
          {1 === 2 && (
            <DveleMap
              modalShow={() => setModalShow(true)}
              locations={locations}
            />
          )}
        </div>
      </div>
    );
  };
  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }
  return isLoaded ? renderMap() : <div></div>;
}

export default App;
